import { useTranslation } from "react-i18next";
import { DateUtils } from "../../../../../utils";
import './OtherDocCard.scss';
import { useHistory } from "react-router-dom";

export const OtherDocCard = ({
  addDoc, petition, hasAction = true
}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const clickable = hasAction && ['PENDING', 'DATA_COMPLETED', 'REGISTERED'].includes(addDoc.status);
  return (
    <button
      key={addDoc.id}
      className="OtherDocsCard"
      type="button"
      aria-label={t('Globals.seeRequest')}
      onClick={clickable ? () => {
        if (addDoc.status === 'REGISTERED') history.push(`/petitions/${petition.petitionId}/other-documents/${addDoc.id}`, {
          petition: petition
        })
      } : null}
    >
      <img 
        className='icon-left'
        src={addDoc.status === 'REGISTERED' ? "/misc/icons/step-ok.png" : "/misc/icons/status-pendingDoc.png"}
        alt=" "
      />
      <div className="document-data">
        <div className="document-data-row">
          {
            addDoc.registerNumber && (
              <div className="document-column">
                <p className="document-column-title">{t('Petitions.OtherDocs.OtherDocsList.name')}</p>
                <p className="document-column-value">{addDoc.registerNumber}</p>
              </div>
            )
          }
          <div className="document-column">
            <p className="document-column-title">{t('Petitions.OtherDocs.OtherDocsList.creationDate')}</p>
            <p className="document-column-value">{DateUtils.getFormatedDate(addDoc.creationTime)}</p>
          </div>
        </div>
      </div>
    </button>
  );
}